import { ChangeDetectionStrategy, Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { OrderformFascade } from '../../fascades/orderform.fascade';
import { map } from 'rxjs/operators';
import { OrderformFooterMenu } from '@orderform/widgets';
import { IframeModalComponent } from '../iframe-modal/iframe-modal.component';
import { getGETParameters } from '../../misc/page-parameter';
import { IframeModalService } from '../iframe-modal/iframe-modal.service';

@Component({
  selector: 'orderform-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  public footerMenuItems$ = this._orderformFascade.settings$.pipe(map((settings) => settings.static_texts.footer_menu));

  public affiliate$ = this._orderformFascade.affiliateName$;

  public year = new Date().getFullYear();

  public reseller$ = this._orderformFascade.settings$.pipe(map((settings) => settings.static_texts.reseller));

  public isNotPrivateSiteowner$ = this._orderformFascade.config$.pipe(map((config) => !config.is_private_siteowner));

  staticBrand = (window as any).SITEOWNER_BRAND;

  constructor(
    private _orderformFascade: OrderformFascade,
    @Inject(LOCALE_ID) public locale: string,
    private _iframeModal: IframeModalService
  ) {}

  openModal(menu: OrderformFooterMenu) {
    const urlCopy = menu.url;
    if (urlCopy.toLowerCase().startsWith('javascript:')) {
      const code = urlCopy.replace('javascript:', '');
      const func = new Function(code);
      if (func) {
        func();
      }
    } else {
      this._iframeModal.open(menu.label, menu.url);
    }
  }

  trackByLabel(index: number, item: OrderformFooterMenu) {
    return item.label;
  }
}
